import { useEffect, useRef } from 'react';

export function useInterval(callback: () => void, delay: number, enabled = true): void {
    const savedCallback = useRef(callback);

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        if (!enabled) return;

        const id = setInterval(() => savedCallback.current(), delay);
        return () => clearInterval(id);
    }, [delay, enabled]);
}
